import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { getCRE_Licenses } from "redux/actions/volumetricsInventory/volumetricsInvAction";

export const LicensesComponent = ({ state, dispatchAction = () => null }) => {
  const dispatch = useDispatch();
  const { token } = useSelector(({ login }) => login);
  const { creLicenses } = useSelector(({ volumetricInv }) => volumetricInv);

  const options = useMemo(
    () =>
      creLicenses
        .filter((license) => license.creLicense)
        .map((license) => ({
          ...license,
          label: `${license.name} - ${license.creLicense}`,
          value: license.creLicense,
        })),
    [creLicenses]
  );

  useEffect(() => {
    dispatch(getCRE_Licenses(token));
  }, [dispatch, token]);

  return (
    <Grid item xs={12} sm={3}>
      <Autocomplete
        id="cre-licenses-select"
        options={options}
        value={state?.creLicenseSelected || null}
        getOptionLabel={(option) => option?.label || ""}
        getOptionSelected={(option, value) => option.value === value.value}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Licencia CRE"
            variant="outlined"
            size="small"
          />
        )}
        fullWidth
        onChange={(_e, v) => dispatch(dispatchAction("creLicenseSelected", v))}
        noOptionsText="No se encontraron licencias"
      />
    </Grid>
  );
};
